import { render, staticRenderFns } from "./knowledge-form.vue?vue&type=template&id=67ec7551"
import script from "./knowledge-form.vue?vue&type=script&lang=ts"
export * from "./knowledge-form.vue?vue&type=script&lang=ts"
import style0 from "./knowledge-form.vue?vue&type=style&index=0&id=67ec7551&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports